import { cn } from "@/lib/cn";
import type { HTMLAttributes, ReactNode } from "react";

type Tone = "default" | "accent" | "warn" | "danger" | "success" | "muted";

const tones: Record<Tone, string> = {
  default: "bg-surface-subtle text-ink border-hairline",
  accent: "bg-accent-dim text-accent border-accent/30",
  warn: "bg-amber/15 text-amber border-amber/30",
  danger: "bg-danger/15 text-danger border-danger/30",
  success: "bg-green/15 text-green border-green/30",
  muted: "bg-surface-subtle text-muted border-hairline",
};

export function Badge({
  children,
  tone = "default",
  className,
  ...rest
}: {
  children: ReactNode;
  tone?: Tone;
  className?: string;
} & HTMLAttributes<HTMLSpanElement>) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded border px-1.5 py-0.5 text-[11px] font-medium leading-none",
        tones[tone],
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  );
}
